import { useMemo } from 'react';
import { CardBrands, getCardBrand } from '../utils';

export const useCardBrand = (cardNumber: string): CardBrands | undefined => {
  return useMemo(() => {
    const unmaskedCardNumber = cardNumber.replaceAll('X', '0').replaceAll('*', '0');
    return getCardBrand(unmaskedCardNumber);
  }, [cardNumber]);
};
